import "./coperative.css"

const Coperative = () => {
    return (
        <div className="coperative">
            the coperative
        </div>
    )
}

export default Coperative
